// extracted by mini-css-extract-plugin
export default {"root":"Loader__root--O2cuv","centered":"Loader__centered--cCYIS","modal":"Loader__modal--1l3xW"};